/**
 * Host Main Page
 *
 * Show all of the hosts' active games, and allow them to select one.
 * Multi-template events (same client + date) are grouped with a combined scores entry point.
 */
import React from 'react'
import { navigate } from '../../utils/navigate'
import dayjs from 'dayjs'

import HostContext from '../../utils/host-context'
import HostLoginWrapper from '../../components/host/login-wrapper'

import SvgCirclePlus from '../../components/svg/plus-circle'

function HuntCard({ hunt, onSelect }) {
  return (
    <div
      className="card mb-2"
      onClick={() => onSelect(hunt.id)}
      onKeyDown={e => {
        if (e.key === `Enter` || e.key === ` `) onSelect(hunt.id)
      }}
      role="button"
      tabIndex={0}>
      <div className="card-body py-2">
        <div className="row align-items-center">
          <div className="col">
            <h4 className="h6 mb-0">{hunt.display_title ? hunt.display_title : hunt.title}</h4>
            {hunt.client && (
              <span className="d-block team-details">
                <strong>Client</strong> {hunt.client}
              </span>
            )}
          </div>
          <div className="col-auto">
            <SvgCirclePlus />
          </div>
        </div>
      </div>
    </div>
  )
}

export default class HostIndexPage extends React.Component {
  render() {
    return (
      <HostLoginWrapper>
        <HostContext.Consumer>
          {({ get_hunt_groups, loaded }) => {
            const { multiGroups, singles } = get_hunt_groups ? get_hunt_groups() : { multiGroups: [], singles: [] }
            const hasHunts = multiGroups.length > 0 || singles.length > 0

            return (
              <>
                <div className="site-sub-header px-4 py-4 mb-4">
                  <h1 className={`title h5 text-uppercase mb-0`}>Choose a Hunt</h1>
                </div>
                <div className="content px-4 pb-5">
                  {!loaded && <p>Loading...</p>}
                  {loaded && !hasHunts && <p>You don't have any hunts today!</p>}
                  <div className="row">
                    {multiGroups.map(group => (
                      <div className="col-md-6" key={group.key}>
                        <div className="card mb-3">
                          <div className="card-header">
                            <h3 className="card-title mb-0">
                              {group.location || group.city || `Combined Games`}
                            </h3>
                            {group.city && group.location && (
                              <span className="d-block team-details">{group.city}</span>
                            )}
                            {group.event_date && (
                              <span className="d-block team-details">
                                {dayjs(group.event_date).format(`MM/DD/YYYY h:mm A`)}
                              </span>
                            )}
                            <span className="d-block team-details">{group.hunts.length} games</span>
                          </div>
                          <div className="card-body">
                            {group.hunts.map(hunt => (
                              <HuntCard
                                key={hunt.id}
                                hunt={hunt}
                                onSelect={id => navigate(`/host/hunt/#${id}`)}
                              />
                            ))}
                          </div>
                        </div>
                      </div>
                    ))}
                    {singles.map(hunt => (
                      <div className="col-md-6" key={hunt.id}>
                        <div className="card mb-3" onClick={() => navigate(`/host/hunt/#${hunt.id}`)}>
                          <div className="card-header">
                            <div className="row">
                              <div className="col-9">
                                <h3 className="card-title mb-0">
                                  {hunt.display_title ? hunt.display_title : hunt.title}
                                </h3>
                              </div>
                              <div className={`col text-right`}>
                                <SvgCirclePlus />
                              </div>
                            </div>
                          </div>
                          <div className="card-body">
                            <p className="mb-0">
                              <span className={`d-block team-details`}>
                                <strong>Event Date</strong>
                                {` `}
                                {hunt.event_date
                                  ? dayjs(hunt.event_date).format(`MM/DD/YYYY h:mm A`)
                                  : hunt.start
                                  ? dayjs(hunt.start).format(`MM/DD/YYYY h:mm A`)
                                  : `—`}
                              </span>
                              {hunt.end && (
                                <span className={`d-block team-details`}>
                                  <strong>Ends</strong>
                                  {` `}
                                  {dayjs(hunt.end).format(`MM/DD/YYYY h:mm A`)}
                                </span>
                              )}
                              {hunt.location && (
                                <span className={`d-block team-details`}>
                                  <strong>Location</strong> {hunt.location}
                                </span>
                              )}
                              {hunt.client && (
                                <span className={`d-block team-details`}>
                                  <strong>Client</strong> {hunt.client}
                                </span>
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )
          }}
        </HostContext.Consumer>
      </HostLoginWrapper>
    )
  }
}
